module.exports = __webpack_public_path__ + "static/img/4_000.61ff7f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4/4_000.jpg
// module id = LFKx
// module chunks = 1